export const DEFAULT_MENU_PREFERENCES = {
  dietaryPreferences: [],
  allergies: [],
  costRange: 'medium',
  mealsToConsider: ['breakfast', 'lunch', 'dinner'],
  daysToPlan: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  selectedWeeks: [0],
  cuisinePreferences: [],
  spiceLevel: 3,
  mealPrepRecipes: false,
  lowCarb: false,
  highProtein: false,
  mealVariety: 'medium',
  proteinPreferences: [],
  weeklyMealCount: 7,
  weeklyEmailEnabled: true
};

export const WEEKLY_MEAL_COUNT_OPTIONS = [3, 5, 7, 10, 14, 21];
export const MIN_WEEKLY_MEAL_COUNT = 1;
export const MAX_WEEKLY_MEAL_COUNT = 21;

export const DIETARY_OPTIONS = ['Vegetarian', 'Vegan', 'Gluten-Free', 'Dairy-Free', 'Keto', 'Paleo', 'Pescatarian'];
export const ALLERGY_OPTIONS = ['Nuts', 'Shellfish', 'Eggs', 'Soy', 'Wheat', 'Fish', 'Sesame'];
export const DEFAULT_CUISINE_OPTIONS = ['Italian', 'Mexican', 'Asian', 'Mediterranean', 'American', 'Indian', 'Japanese', 'Thai', 'French', 'Greek'];
export const PROTEIN_OPTIONS = ['Fish', 'Shellfish', 'Poultry', 'Beef', 'Pork', 'Lamb'];
export const MEAL_OPTIONS = [
  { value: 'breakfast', label: 'Breakfast' },
  { value: 'lunch', label: 'Lunch' },
  { value: 'dinner', label: 'Dinner' },
  { value: 'snack', label: 'Snack' }
];
export const COST_OPTIONS = [
  { value: 'low', label: 'Budget-Friendly' },
  { value: 'medium', label: 'Moderate' },
  { value: 'high', label: 'Premium' }
];
export const VARIETY_OPTIONS = [
  { value: 'high', label: 'High Variety', description: 'All different meals each day' },
  { value: 'medium', label: 'Medium Variety', description: 'Can repeat 2-3 times per week' },
  { value: 'low', label: 'Low Variety', description: 'Can repeat the same meal multiple days' },
  { value: 'none', label: 'No Variety', description: 'Same meals every day' }
];
export const SPICE_LABELS = ['Mild', 'Mild+', 'Medium', 'Hot', 'Extra Hot'];
